import React, {useRef, useEffect, forwardRef} from 'react';
import {UI, Image} from 'components';
import {includes, size, kebabCase, getElementAttributes, clamp, stopPropagation} from 'helpers';
import css from './card.module.scss';

export function Header({ children }) {
  return (
    <header className={css.header}>
      { children }
    </header>
  );
}

export function Group({ className, ...props }) {
  return (
    <div className={css('group', className)} {...props} />
  );
}

export function Toolbar({ className, ...props }) {
  const ref = useRef();
  useEffect(() => {
    if (!includes(className, 'no-mask')) {
      const body = ref.current.closest(`.${css.card}`).querySelector(`.${css.body}`);
      body?.classList.add(css('has-toolbar'));
    }
  }, []);
  return (
    <div className={css('toolbar', className)} onClick={stopPropagation} {...props} ref={ref} />
  );
}

export const Footer = forwardRef((props, ref) =>
  <div className={css('footer', props)} ref={ref}>
    { props.children }
  </div>
);

export function RightMenu({ className, ...props }) {
  return (
    <div className={css('right-menu', className)} {...props} />
  );
}

export function Gallery({ images }) {
  return size(images) > 0 && (
    <div className={css.gallery}>
      { images.map(image =>
        <Thumbnail key={image.id} src={image.url} />
      ) }
    </div>
  );
}

export const Progress = forwardRef(({ now, max = 1, position = 'below', children, className, ...props }, ref) =>
  <div className={css('progress', props, position, className)} {...props} ref={ref} role="progressbar" aria-valuenow={now} aria-valuemax={max} >
    { position == 'above' && children }
    <div className={css('progress-bar')}>
      { !isNaN(now / max) &&
        <div className={css('progress-filler')} style={{ width: `${clamp(now / max, 0, 1)*100}%` }} />
      }
      { position == 'inside' &&
        <div className={css('progress-label')}>{ children }</div>
      }
    </div>
    { position == 'below' && children }
  </div>
);

export function Thumbnail(props) {
  if (props.src) {
    return (
      <Image className={css('thumbnail', props)} src={props.src} />
    );
  }
  return (
    <figure className={css('thumbnail', props, kebabCase(props.background))} />
  );
}

export function Status({ className, containerClassName, ...props }) {
  return (
    <div className={css('status-container', containerClassName)}>
      <div {...getElementAttributes(props)} className={css('status', className)} />
    </div>
  );
}

export const Body = forwardRef(({ className, ...props }, ref) =>
  <div className={css('body', { className })} ref={ref} {...getElementAttributes(props)} />
);

export const Cover = forwardRef((props, ref) =>
  <div {...props} className={css('cover', props)} ref={ref} />
);

export function Text({ className, ...props }) {
  return (
    <UI.Text {...props} className={css('text', className)} />
  );
}

export function Highlight(props) {
  return (
    <span {...props} className={css('highlight', props)}>
      { props.children }
    </span>
  );
}

export function Note(props) {
  return (
    <UI.Text {...props} className={css('note', props)} />
  );
}

export function Dropzone(props) {
  return (
    <div className={css.dropzone}>{ props.children }</div>
  );
}

export const HoverIcon = ({className, ...props}) => (
  <UI.Icon {...props} className={css('hover-icon', className)} />
);

export function CustomList(props) {
  return (
    <UI.Text {...props} className={css('note', props)} />
  );
}
